import React from 'react';
import Navbar from '../Shared/Navbar';

const About = () => {
    return (
        <div>
            <Navbar></Navbar>
        </div>
    );
};

export default About;